import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "App-Trans-H" }
const _hoisted_2 = { class: "App-Trans-Tal" }
const _hoisted_3 = {
  style: {"line-height":"18px"},
  class: "App-Trans-T"
}
const _hoisted_4 = {
  key: 0,
  "m-tb-0": "",
  "f-w-700": ""
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  "mute-primary": "",
  style: {"padding-right":"8px"}
}
const _hoisted_7 = { "mute-secondary": "" }
const _hoisted_8 = { class: "App-Trans" }
const _hoisted_9 = {
  key: 0,
  "m-tb-0": "",
  "f-w-600": ""
}
const _hoisted_10 = {
  "m-tb-0": "",
  "f-w-600": ""
}
const _hoisted_11 = {
  key: 0,
  style: {"padding-right":"4px"}
}
const _hoisted_12 = { class: "App-Trans-Fo" }
const _hoisted_13 = {
  "m-tb-0": "",
  "f-w-700": "",
  primary: ""
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_truncate = _resolveComponent("app-truncate")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BidPayModal = _resolveComponent("BidPayModal")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_blur = _resolveDirective("blur")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, { content: "Visit the opportunity" }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: `/opportunities/${_ctx.transaction.opportunity._id}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.transaction.opportunity !== undefined)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.transaction.opportunity.outcome) + " Opportunity ", 1))
                  : _createCommentVNode("", true),
                (_ctx.business)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.business.name), 1),
                      _createElementVNode("span", _hoisted_7, " Sent " + _toDisplayString(_ctx.$moment(_ctx.transaction.createdAt).fromNow()), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1)),
      _createElementVNode("div", null, [
        (_ctx.transaction.talent !== undefined)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", { "mute-secondary": "" }, " Paying for ", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tooltip, { content: "See talent's page" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/talent/${_ctx.transaction.talent._id}/${_ctx.transaction.opportunity._id}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", _hoisted_10, [
                  (
                  _ctx.transaction.talent.headline ||
                  _ctx.transaction.talent.areaOfExpertise
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$filters.capitalize(
                    _ctx.transaction.talent.headline ||
                      _ctx.transaction.talent.areaOfExpertise
                  )), 1))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createElementBlock("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.transaction.talent.firstName)) + " " + _toDisplayString(_ctx.$filters.capitalize(_ctx.transaction.talent.lastName)), 1)
                  ])), [
                    [_directive_blur, _ctx.transaction.talent]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { style: {"margin":"12px 0"} }),
        (_ctx.transaction.bidding)
          ? (_openBlock(), _createBlock(_component_app_truncate, {
              key: 1,
              onViewMore: _cache[0] || (_cache[0] = ($event: any) => (_ctx.max = 20000)),
              max: _ctx.max,
              content: _ctx.transaction.bidding.description
            }, null, 8, ["max", "content"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_row, {
          gutter: 12,
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, {
                  "is-borderless": "",
                  type: 
                _ctx.transaction.status === 'canceled'
                  ? 'danger'
                  : _ctx.transaction.status === 'succeeded'
                  ? 'success'
                  : 'warning'
              ,
                  "is-rounded": "",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.transaction.status)), 1)
                  ]),
                  _: 1
                }, 8, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 11,
              "txt-right": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.talentPrice.symbol) + _toDisplayString(_ctx.transaction.amount), 1),
                (_ctx.transaction.status !== 'succeeded')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      false
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.payingModelOpen = true)),
                            loading: _ctx.loadingPay,
                            "is-borderless": "",
                            type: "primary",
                            round: "",
                            size: "mini",
                            icon: "el-icon-cancel"
                          }, {
                            default: _withCtx(() => [
                              _cache[5] || (_cache[5] = _createTextVNode("Pay ", -1)),
                              (_ctx.talentPrice !== undefined)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.talentPrice.symbol) + " " + _toDisplayString(_ctx.talentPrice.amount), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["loading"]))
                        : _createCommentVNode("", true),
                      (_ctx.talentPrice !== undefined && _ctx.transaction.bidding)
                        ? (_openBlock(), _createBlock(_component_BidPayModal, {
                            key: 1,
                            talentPrice: _ctx.talentPrice,
                            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.payingModelOpen = false)),
                            isOpen: _ctx.payingModelOpen,
                            talent: _ctx.transaction.bidding.talent,
                            opportunity: _ctx.transaction.opportunity,
                            bidding: _ctx.transaction.bidding
                          }, null, 8, ["talentPrice", "isOpen", "talent", "opportunity", "bidding"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}